export const ADMIN_MENU_TREE_MODULE = "ADMIN_MENU";
export const ADMIN_MENU_TREE_PANEL_ID = "0";

export const GET_MENU_TREE_FOCUS_SUCCESS = "GET_MENU_TREE_FOCUS_SUCCESS";
